let Format = require("../lib/Format");

class PlotBoxes extends React.Component {
  componentDidMount() {
    this.plot();
  }

  componentDidUpdate() {
    this.plot();
  }

  plot() {
    let {
      data,
      getX,
      getY,
      scaleX,
      scaleY,
      color,
      stroke,
      opacity
    } = this.props;

    let ref = this.refs.boxes;

    let w = 18;

    let fx = (d, i) => scaleX(getX(d, i));

    let fy = (d, key) => scaleY(getY(d[key]));

    d3.select(ref)
      .selectAll("g")
      .remove();

    let g = d3.select(ref)
      .selectAll("g")
      .data(data);

    g = g
      .enter()
      .append("g");

    [["min", "q1"], ["q3", "max"]].forEach(([k1, k2]) => {
      g
        .append("line")
        .attr("x1", fx)
        .attr("x2", fx)
        .attr("y1", (d) => fy(d, k1))
        .attr("y2", (d) => fy(d, k2))
        .attr("stroke", color)
        .attr("stroke-width", stroke);
    });

    g
      .append("rect")
      .attr("x", (d, i) => fx(d, i) - (w / 2))
      .attr("y", (d) => fy(d, "q3"))
      .attr("width", w)
      .attr("height", (d) => fy(d, "q1") - fy(d, "q3"))
      .attr("stroke", color)
      .attr("stroke-width", stroke)
      .attr("fill", color)
      .attr("fill-opacity", opacity)
      .attr("data-tooltip", (d) => "Median = " + (d.median ? Format.number(d.median, 2) : "?"));

    ["min", "median", "max"].forEach((k) => {
      g
        .append("line")
        .attr("x1", (d, i) => fx(d, i) - (w / 2))
        .attr("x2", (d, i) => fx(d, i) + (w / 2))
        .attr("y1", (d) => fy(d, k))
        .attr("y2", (d) => fy(d, k))
        .attr("stroke", color)
        .attr("stroke-width", stroke)
        .style("pointer-events", "none");
    });
  }

  render() {
    return (
      <g className="mc-plot-boxes" ref="boxes"/>
    );
  }
}

PlotBoxes.defaultProps = {
  color: "#304561",
  stroke: 1,
  opacity: 0.35
};

module.exports = PlotBoxes;